<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Director's Message</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a routerLink="javascript:void(0);">Director's Message</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="chairman-msg ptb--100 ">
  <div class="container">
    <div class="row ">
      <div class="col-12 col-lg-9">
        <!-- <blockquote class="blockquote-div">
                    <p>Education is not the learning of facts, but the training of the mind to think
                    </p>
                    <h6>- Albert Einstein</h6>
                </blockquote> -->
        <p>I am glad to know that GHRCACS is growing towards the successful organization in the education era. The
          college is giving a platform to the student through the various indoor and outdoor activities so that it has
          become a forum which could aptly are used an exposure for student’s inner qualities and hidden talents. It
          will definitely help students to build their personality. I convey my good wishes to all faculty members,
          parents and students for the future.</p>
        <p>It gives me great pride and satisfaction to write about GHRCACS, we encourage self-governing thinking that
          helps students in developing holistic perception, strong domain knowledge, contemporary skill sets and
          positive attitude. </p>
        <p>We, at GHRCACS provide excellent infrastructure, competent faculty, strong industry connect, lush green
          environment for learning and all other facilities required for modern education. The main aim of the GHRCACS
          is to provide modern education in the field of Arts, Commerce, and Science & Computer to the youth.</p>
        <p>Thank You!</p>

        <!-- <blockquote class="blockquote-div mt-3">
                    <p>Think Education Think Raisoni
                    </p>
                </blockquote> -->
      </div>
      <div class="col-12 col-lg-3">
        <img src="{{baseUrl}}/faculty/director-harish.avif" alt="Dr. Praveen Jangade | GHRCACS, PUNE" class="img-fluid">
        <div class="box">
          <h4>Dr. H. R. Kulkarni</h4>
          <p>Director, GHRCACS</p>
        </div>
      </div>
    </div>

  </div>
</section>
